// material
import { Box, BoxProps } from '@mui/material';

// ----------------------------------------------------------------------

export default function PageNotFoundIllustration({ ...other }: BoxProps) {
  return <Box {...other} component="img" src={`/static/illustrations/illustration_404.svg`}></Box>;
}
